import { Box, Grid, TextField, Typography } from "@mui/material";
import { ArrowForward, Close, Done } from "@mui/icons-material";

import Theme from "../../../../../utils/Theme";
import { SalesAidsStyles } from "./SalesAidsStyles";
import { generateRandomId } from "../../../../../utils/Utils";
import AddIconUtils from "../../../../../utils/AddIconUtils";

const SurveyArtifact = ({
  artifacts,
  setArtifacts,
  handleArrowClick,
  handleRemove,
}) => {
  const handleTextChange = (index, field, value) => {
    setArtifacts((prev) => ({
      ...prev,
      survey: prev?.survey?.map((item, i) =>
        i === index
          ? {
              ...item,
              [field]: value,
              isEdit: true,
            }
          : item
      ),
    }));
  };

  const handleOptionChange = (index, optionIndex, value, field) => {
    setArtifacts((prev) => ({
      ...prev,
      survey: prev?.survey?.map((item, i) =>
        i === index
          ? {
              ...item,
              [field]: (item[field]?.length ? item[field] : Array(4).fill("")).map(
                (option, j) => (j === optionIndex ? value : option)
              ),
              isEdit: true,
            }
          : item
      ),
    }));
  };

  const handleAddNew = () => {
    const newSurveyArtifact = {
      question: "",
      es_question: "",
      options: ["", "", "", ""],
      es_options: ["", "", "", ""],
      position: null,
      artifactId: generateRandomId(6),
      isEdit: false,
    };
    setArtifacts((prev) => ({
      ...prev,
      survey: [...prev?.survey, newSurveyArtifact],
    }));
  };

  return (
    <Box sx={SalesAidsStyles.outerBox}>
      {artifacts?.map((item, index) => (
        <Box
          key={item?.id || item?.artifactId}
          sx={{
            ...SalesAidsStyles.innerBox,
            bgcolor: item?.isEdit ? "#FFF7F7" : null,
          }}
        >
          <Close
            sx={SalesAidsStyles.closeIcon}
            onClick={() => handleRemove(item, "survey")}
          />

          {/* English Section */}
          <Box sx={SalesAidsStyles.subheadingBox}>
            <Typography sx={SalesAidsStyles.wordStyle}>English</Typography>
            <TextField
              fullWidth
              variant="outlined"
              label={"Message to be displayed"}
              onChange={(e) =>
                handleTextChange(index, "question", e.target.value)
              }
              value={item?.question}
              multiline
            />

            <Grid container spacing={2}>
              {(item?.options?.length ? item.options : Array(4).fill("")).map(
                (option, optIndex) => (
                  <Grid
                    item
                    xs={6}
                    key={`en-${optIndex}`}
                    sx={{ display: "flex" }}
                  >
                    <TextField
                      fullWidth
                      variant="outlined"
                      sx={SalesAidsStyles.surveyButton}
                      value={option || ""}
                      onChange={(e) =>
                        handleOptionChange(
                          index,
                          optIndex,
                          e.target.value,
                          "options"
                        )
                      }
                    />
                  </Grid>
                )
              )}
            </Grid>
          </Box>

          {/* Spanish Section */}
          <Box sx={SalesAidsStyles.subheadingBox}>
            <Typography sx={SalesAidsStyles.wordStyle}>Spanish</Typography>
            <TextField
              fullWidth
              variant="outlined"
              label={"Mensaje a mostrar"}
              onChange={(e) =>
                handleTextChange(index, "es_question", e.target.value)
              }
              value={item?.es_question}
              multiline
            />

            <Grid container spacing={2}>
              {(
                item?.es_options?.length ? item.es_options : Array(4).fill("")
              ).map((option, optIndex) => (
                <Grid
                  item
                  xs={6}
                  key={`es-${optIndex}`}
                  sx={{ display: "flex" }}
                >
                  <TextField
                    fullWidth
                    variant="outlined"
                    sx={SalesAidsStyles.surveyButton}
                    value={option || ""}
                    onChange={(e) =>
                      handleOptionChange(
                        index,
                        optIndex,
                        e.target.value,
                        "es_options"
                      )
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </Box>

          {/* Action Buttons */}
          {item?.isEdit ? (
            <Done
              sx={{
                ...SalesAidsStyles.doneIcon,
                color: (
                  (item?.question?.trim() &&
                    item?.options?.some((opt) => opt?.trim())) ||
                  (item?.es_question?.trim() &&
                    item?.es_options?.some((opt) => opt?.trim()))
                )
                  ? Theme.palette.primary.main
                  : Theme.palette.action.disabled,
                cursor: (
                  (item?.question?.trim() &&
                    item?.options?.some((opt) => opt?.trim())) ||
                  (item?.es_question?.trim() &&
                    item?.es_options?.some((opt) => opt?.trim()))
                )
                  ? "pointer"
                  : "not-allowed",
              }}
              onClick={() => handleArrowClick(item, "survey")}
            />
          ) : (
            <ArrowForward
              sx={{
                ...SalesAidsStyles.arrowForward,
                color: (
                  (item?.question?.trim() &&
                    item?.options?.some((opt) => opt?.trim())) ||
                  (item?.es_question?.trim() &&
                    item?.es_options?.some((opt) => opt?.trim()))
                )
                  ? Theme.palette.primary.main
                  : Theme.palette.action.disabled,
                cursor: (
                  (item?.question?.trim() &&
                    item?.options?.some((opt) => opt?.trim())) ||
                  (item?.es_question?.trim() &&
                    item?.es_options?.some((opt) => opt?.trim()))
                )
                  ? "pointer"
                  : "not-allowed",
              }}
              onClick={() => handleArrowClick(item, "survey")}
            />
          )}
        </Box>
      ))}

      <AddIconUtils
        artifacts={artifacts}
        handleAddNew={handleAddNew}
        total={10}
      />
    </Box>
  );
};

export default SurveyArtifact;
